import { COLORS } from '../../../utils/Application_Constants';

const ExpenseStatusEnum = {
    0: { value: 'PendingSubmission', UI: 'Pending Submission' },
    1: { value: 'Submitted', UI: 'Submitted' },
    2: { value: 'InProcess', UI: 'In Process' },
    3: { value: 'TcApproved', UI: 'TC Approved' },
    4: { value: 'New', UI: 'New' },
    5: { value: 'ReadyForReview', UI: 'Ready for Review' },
    6: { value: 'NeedsApproval', UI: 'Needs Approval' },
    7: { value: 'NonReimbursable', UI: 'Non-Reimbursable' },
    8: { value: 'Rejected', UI: 'Rejected' },
    9: { value: 'NeedMoreInformation', UI: 'Need More Information' },
    10: { value: 'ReturnedByAccounting', UI: 'Returned by Accounting' },
    11: { value: 'OnHoldMatchPending', UI: 'Match Pending' },
    12: { value: 'OnHoldPendingAirfare', UI: 'Pending Airfare' },
    13: { value: 'OnHoldAirlineCreditOnFile', UI: 'Airline Credit On File' },
    14: { value: 'OnHoldDisputed', UI: 'Disputed' },
    15: { value: 'OnHoldAdvancedDeposit', UI: 'Advanced Deposit' },
    16: { value: 'OnHoldReimbursement', UI: 'Reimbursement On Hold' },
    17: { value: 'Abandoned', UI: 'Abandoned' },
    18: { value: 'Matched', UI: 'Matched' },
    19: { value: 'Approved', UI: 'Approved' },
    20: { value: 'Posted', UI: 'Posted' },
    21: { value: 'Dispute', UI: 'Dispute' },
    22: { value: 'ToBeSentToWorkday', UI: 'To Be Sent to Workday' },
    23: { value: 'AwaitingEndDate', UI: 'Awaiting End Date' },
    24: { value: 'MCOCredit', UI: 'MCO/Credit' },
    25: { value: 'Processed', UI: 'Processed' },
    26: { value: 'Grouped', UI: 'Grouped' },
};

const ExpenseVaultStatusEnum = {
    1: { value: 'ReadyForReview', UI: 'Ready for Review' },
    2: { value: 'NeedsApproval', UI: 'Needs Approval' },
    3: { value: 'Approved', UI: 'Approved' },
    4: { value: 'Posted', UI: 'Posted' },
};

const ExpenseStatusIdsEnum = {
    New: 0,
    InProcess: 1,
    ReadyForReview: 2,
    Rejected: 3,
    OnHoldMatchPending: 4,
    OnHoldPendingAirfare: 5,
    OnHoldAirlineCreditOnFile: 6,
    OnHoldDisputed: 7,
    OnHoldAdvancedDeposit: 8,
    OnHoldReimbursement: 9,
    Abandoned: 10,
    Matched: 11,
    Approved: 12,
    Posted: 13,
    TcApproved: 14,
    NeedMoreInformation: 15,
    Submitted: 16,
    NonReimbursable: 17,
    PendingSubmission: 18,
    ReturnedByAccounting: 19,
};

const ExpenseStatusValuesEnum = {
    PendingSubmission: 'PendingSubmission ',
    Submitted: 'Submitted',
    TcApproved: 'TcApproved',
    New: 'New',
    InProcess: 'InProcess',
    ReadyForReview: 'ReadyForReview',
    NonReimbursable: 'NonReimbursable',
    Rejected: 'Rejected',
    NeedMoreInformation: 'NeedMoreInformation',
    ReturnedByAccounting: 'ReturnedByAccounting',
    OnHoldMatchPending: 'OnHoldMatchPending',
    OnHoldPendingAirfare: 'OnHoldPendingAirfare',
    OnHoldAirlineCreditOnFile: 'OnHoldAirlineCreditOnFile',
    OnHoldDisputed: 'OnHoldDisputed',
    OnHoldAdvancedDeposit: 'OnHoldAdvancedDeposit',
    OnHoldReimbursement: 'OnHoldReimbursement',
    Abandoned: 'Abandoned',
    Matched: 'Matched',
    Approved: 'Approved',
    Posted: 'Posted',
    Dispute: 'Dispute',
    ToBeSentToWorkday: 'To Be Sent to Workday',
    AwaitingEndDate: 'Awaiting End Date',
    MCOCredit: 'MCO/Credit',
    Processed: 'Processed',
    Grouped: 'Grouped',
};

const ExpenseAdminStatusValuesEnum = {
    Submitted: 'Submitted',
    TcApproved: 'TcApproved',
    NeedMoreInformation: 'NeedMoreInformation',
    InProcess: 'InProcess',
    NonReimbursable: 'NonReimbursable',
};

const NonClinicianReimbursementFeatureFlagFilteredStatusValuesEnum = {
    OnHoldMatchPending: 'OnHoldMatchPending',
    OnHoldPendingAirfare: 'OnHoldPendingAirfare',
    OnHoldAirlineCreditOnFile: 'OnHoldAirlineCreditOnFile',
    OnHoldDisputed: 'OnHoldDisputed',
    OnHoldAdvancedDeposit: 'OnHoldAdvancedDeposit',
    Matched: 'Matched',
    Rejected: 'Rejected',
};

const ExpenseStatusChipStyles = {
    chipOnHoldMatchPending: {
        backgroundColor: COLORS.LT_SUNFLOWER25,
        color: '#AD7829',
        borderColor: '#AD7829',
    },
    chipOnHoldPendingAirfare: {
        backgroundColor: COLORS.LT_SUNFLOWER25,
        color: '#AD7829',
        borderColor: '#AD7829',
    },
    chipOnHoldAirlineCreditOnFile: {
        backgroundColor: COLORS.LT_SUNFLOWER25,
        color: '#AD7829',
        borderColor: '#AD7829',
    },
    chipOnHoldDisputed: {
        backgroundColor: COLORS.LT_SUNFLOWER25,
        color: '#AD7829',
        borderColor: '#AD7829',
    },
    chipOnHoldAdvancedDeposit: {
        backgroundColor: COLORS.LT_SUNFLOWER25,
        color: '#AD7829',
        borderColor: '#AD7829',
    },
    chipOnHoldReimbursement: {
        backgroundColor: COLORS.LT_SUNFLOWER25,
        color: '#AD7829',
        borderColor: '#AD7829',
    },
    chipInCorrection: {
        backgroundColor: COLORS.LT_JOURNEY10,
        color: COLORS.LT_JOURNEY,
        borderColor: COLORS.LT_JOURNEY,
    },
    chipReadyForReview: {
        backgroundColor: COLORS.LT_JOURNEY10,
        color: COLORS.LT_JOURNEY,
        borderColor: COLORS.LT_JOURNEY,
    },
    chipNeedsApproval: {
        backgroundColor: COLORS.LT_JOURNEY10,
        color: COLORS.LT_JOURNEY,
        borderColor: COLORS.LT_JOURNEY,
    },
    chipInProcess: {
        backgroundColor: COLORS.LT_JOURNEY10,
        color: COLORS.LT_JOURNEY,
        borderColor: COLORS.LT_JOURNEY,
    },
    chipNew: {
        backgroundColor: COLORS.LT_JOURNEY10,
        color: COLORS.LT_JOURNEY,
        borderColor: COLORS.LT_JOURNEY,
    },
    chipApproved: {
        backgroundColor: COLORS.LT_EMERALD10,
        color: COLORS.LT_EMERALD,
        borderColor: COLORS.LT_EMERALD,
    },
    chipMatched: {
        backgroundColor: COLORS.LT_EMERALD10,
        color: COLORS.LT_EMERALD,
        borderColor: COLORS.LT_EMERALD,
    },
    chipAbandoned: {
        backgroundColor: COLORS.LT_EMERALD10,
        color: COLORS.LT_EMERALD,
        borderColor: COLORS.LT_EMERALD,
    },
    chipPosted: {
        backgroundColor: COLORS.LT_EMERALD10,
        color: COLORS.LT_EMERALD,
        borderColor: COLORS.LT_EMERALD,
    },
    chipMissingInformation: {
        backgroundColor: COLORS.LT_PEPPER10,
        color: COLORS.LT_PEPPER,
        borderColor: COLORS.LT_PEPPER,
    },
    chipRejected: {
        backgroundColor: COLORS.LT_PEPPER10,
        color: COLORS.LT_PEPPER,
        borderColor: COLORS.LT_PEPPER,
    },
    chipNonReimbursable: {
        backgroundColor: COLORS.LT_PEPPER10,
        color: COLORS.LT_PEPPER,
        borderColor: COLORS.LT_PEPPER,
    },
    chipAssigned: {
        backgroundColor: COLORS.LT_EMERALD10,
        color: COLORS.LT_EMERALD,
        borderColor: COLORS.LT_EMERALD,
    },
    chipUnassigned: {
        backgroundColor: COLORS.LT_JOURNEY10,
        color: COLORS.LT_JOURNEY,
        borderColor: COLORS.LT_JOURNEY,
    },
    chipTcApproved: {
        backgroundColor: COLORS.LT_JOURNEY10,
        color: COLORS.LT_JOURNEY,
        borderColor: COLORS.LT_JOURNEY,
    },
    chipNeedMoreInformation: {
        backgroundColor: COLORS.LT_SUNFLOWER25,
        color: '#AD7829',
        borderColor: '#AD7829',
    },
    chipReturnedByAccounting: {
        backgroundColor: COLORS.LT_SUNFLOWER25,
        color: '#AD7829',
        borderColor: '#AD7829',
    },
    chipPendingSubmission: {
        backgroundColor: COLORS.LT_JOURNEY10,
        color: COLORS.LT_JOURNEY,
        borderColor: COLORS.LT_JOURNEY,
    },
    chipSubmitted: {
        backgroundColor: COLORS.LT_JOURNEY10,
        color: COLORS.LT_JOURNEY,
        borderColor: COLORS.LT_JOURNEY,
    },
    chipGrouped: {
        backgroundColor: COLORS.LT_EMERALD10,
        color: COLORS.LT_EMERALD,
        borderColor: COLORS.LT_EMERALD,
    },
    chipProcessed: {
        backgroundColor: COLORS.LT_EMERALD10,
        color: COLORS.LT_EMERALD,
        borderColor: COLORS.LT_EMERALD,
    },
    chipDispute: {
        backgroundColor: COLORS.LT_SUNFLOWER25,
        color: '#AD7829',
        borderColor: '#AD7829',
    },
    chipToBeSentToWorkday: {
        backgroundColor: COLORS.LT_SUNFLOWER25,
        color: '#AD7829',
        borderColor: '#AD7829',
    },
    chipAwaitingEndDate: {
        backgroundColor: COLORS.LT_SUNFLOWER25,
        color: '#AD7829',
        borderColor: '#AD7829',
    },
    chipMCOCredit: {
        backgroundColor: COLORS.LT_SUNFLOWER25,
        color: '#AD7829',
        borderColor: '#AD7829',
    },
};

export {
    ExpenseStatusEnum,
    ExpenseStatusChipStyles,
    ExpenseVaultStatusEnum,
    ExpenseStatusIdsEnum,
    ExpenseStatusValuesEnum,
    ExpenseAdminStatusValuesEnum,
    NonClinicianReimbursementFeatureFlagFilteredStatusValuesEnum,
};
